import React from 'react';
import { Section } from './ui/Section';
import { Accordion } from './ui/Accordion';
import { Button } from './ui/Button';
const faqs = [{
  title: '¿Tengo que contar calorías o pesar comida?',
  content: 'No. Usas una plantilla visual (40/30/30) y reglas simples.'
}, {
  title: '¿Funciona si como fuera de casa o en oficina?',
  content: 'Sí. Hay plantillas para pedir/platos tipo: proteína + verdura + carbo medido.'
}, {
  title: '¿Necesito cocinar mucho?',
  content: 'No. El sistema prioriza opciones rápidas y repetibles; también incluye "kit supermercado".'
}, {
  title: '¿Esto es una dieta para adelgazar?',
  content: 'No es el foco. El foco es energía alta. Si reduces antojos, algunas personas ajustan hábitos, pero no es una promesa.'
}, {
  title: '¿Y si soy vegetariana?',
  content: 'Puedes adaptarlo con legumbres, huevos y lácteos (si los toleras). El principio es estructura: proteína + fibra + energía limpia.'
}, {
  title: '¿Y si estoy en perimenopausia/menopausia?',
  content: 'Puede ayudarte a organizar comidas más estables. No sustituye consejo médico; es un sistema de alimentación práctica.'
}, {
  title: '¿Cuándo notaré cambios?',
  content: 'Muchas personas notan más estabilidad en 3–7 días si aplican comida base + micro-ajuste.'
}, {
  title: '¿Qué pasa si me salto un día?',
  content: 'Nada. Vuelves al sistema al día siguiente. Está diseñado para vida real.'
}, {
  title: '¿Incluye recetas?',
  content: 'Incluye plantillas y combinaciones rápidas. Si quieres, puedes convertirlas en recetas, pero no dependes de eso.'
}, {
  title: '¿Es apto para celiaquía o sin lactosa?',
  content: 'La base es mediterránea flexible. Si se valida, habrá bonus específicos (sin gluten/sin lactosa).'
}];
export function FAQ() {
  return <Section className="bg-[#faf8f5]" data-id="element-123">
      <div className="max-w-3xl mx-auto" data-id="element-124">
        <div className="text-center mb-8" data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2c4a2c] mb-3" data-id="element-126">
            Preguntas frecuentes
          </h2>
          <p className="text-lg text-[#5a5a5a]" data-id="element-127">
            Respuestas directas para que decidas con claridad.
          </p>
        </div>

        <Accordion items={faqs} data-id="element-128" />

        <div className="mt-8 text-center" data-id="element-129">
          <Button size="lg" data-id="element-130">Resolver dudas y comprar</Button>
          <p className="mt-2 text-sm text-[#5a5a5a]" data-id="element-131">
            Si aún dudas: empieza por 7 días y mide tu energía.
          </p>
        </div>
      </div>
    </Section>;
}